import {SwiperDefaultBox} from './swiper.default.box';

export const SwiperBox = SwiperDefaultBox;